<section class="cz-sso-access-only-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button (click)="logout()" class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="row">
      <div class="col-xs-12 error-message">
        <div class="pt-2" [innerHTML]=" errorMessage ? sanitizer.bypassSecurityTrustHtml(errorMessage.message) : ('$sso_error_item_' + this.data.messageId + '_default_value' | translate) "></div>
      </div>
    </div>
    <div class="row bottom-buttons">
      <div class="col-xs-12 center-xs">
        <button mat-flat-button color="accent" (click)="logout()"
          [innerHTML]="'$btn_close' | translate"></button>
      </div>
    </div>
  </mat-dialog-content>
</section>